import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n      /* Move ripple styles to the checkbox */\n      &::after {\n        left: 22px;\n        padding-bottom: 4px;\n        width: 4px;\n      }\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  background-color: ", ";\n  cursor: ", ";\n  display: flex;\n  height: 2.28em;\n  justify-content: space-between;\n  line-height: 2.28em;\n  margin: 0;\n  ", ";\n  ", "\n\n  padding: 0 12px;\n  transition: background-color ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled, { css } from 'styled-components';
import { property, color } from '@scp/ui-shared/theme/variables';
import { withRippleEffect, getFocusedStyle } from '@scp/ui-shared/theme/ripple-effect';
import { Paragraph } from '@scp/ui-shared/components/typography';

var getRippleStyles = function getRippleStyles(_ref) {
  var isMulti = _ref.isMulti,
      isFocused = _ref.isFocused,
      navigatingByKeyboard = _ref.navigatingByKeyboard;
  if (!isFocused || !navigatingByKeyboard) return null;
  if (isMulti) return getFocusedStyle(8);
  return getFocusedStyle(12.4);
};

var getBgColor = function getBgColor(_ref2) {
  var isMulti = _ref2.isMulti,
      isSelected = _ref2.isSelected,
      isFocused = _ref2.isFocused;

  if (isFocused) {
    if (isMulti) return color.backgroundSecondary;
    return isSelected ? color.palette.grey800 : color.backgroundSecondary;
  }

  if (isSelected) return !isMulti ? color.palette.grey800 : 'transparent';
  return 'transparent';
};

var OptionBase = styled(Paragraph).attrs(function (_ref3) {
  var disabled = _ref3.disabled;
  return {
    as: 'div',
    secondary: disabled
  };
})(_templateObject(), getBgColor, function (props) {
  return props.disabled ? 'not-allowed' : 'pointer';
}, getRippleStyles, function (props) {
  return props.isMulti && css(_templateObject2());
}, property.transition);
export var Option = withRippleEffect(OptionBase);